var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDropdown = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12px",
  height: "7px",
  viewBox: "0 0 12 7",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.88.29L6 4.17 2.12.29A.996.996 0 10.71 1.7L5.3 6.29c.39.39 1.02.39 1.41 0L11.3 1.7a.996.996 0 000-1.41c-.39-.38-1.03-.39-1.42 0z"
})));
export default SvgDropdown;